module.exports = __webpack_public_path__ + "img/n8.4cb8072a.png";